import { render, staticRenderFns } from "./weekly-quantities-template-tab.vue?vue&type=template&id=d4b2cbc2&scoped=true"
import script from "./weekly-quantities-template-tab.vue?vue&type=script&lang=js"
export * from "./weekly-quantities-template-tab.vue?vue&type=script&lang=js"
import style0 from "./weekly-quantities-template-tab.vue?vue&type=style&index=0&id=d4b2cbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b2cbc2",
  null
  
)

export default component.exports